import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { API_ROUTES } from "../../../utils/constants";
import { format } from "date-fns";
// import PieChart from "./PieChart";
import "../../../libs/css/custom-bootstrap-margin-padding.css";
import moment from "moment";
import TopNav from "../TopNav";
import Notifications from "../Notifications";
import NavHeader2 from "../NavHeader2";
import Sidebar from "../Sidebar";
import Footer from "../Footer";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import { getToken } from "../../../utils/getToken";
import Swal from "sweetalert2";
import Loaders from "../Loaders";
import Spinner from "../../../Spinner/Spinner";

const SingleMarketerDashboard = (props) => {
  useEffect(() => {
    document.title = "Marketer | Dashboard";
  }, []);
  const { isLoaded, setIsLoaded } = props;
  const [isLoading1, setIsLoading1] = useState(true);
  const [isLoading2, setIsLoading2] = useState(true);
  const [loading, setLoading] = useState(true);
  const [dailySubscriptions, setDailySubscriptions] = useState([]);
  const [dailyRevenue, setDailyRevenue] = useState([]);
  const [marketersCost, setMarketersCost] = useState("");
  const [totalMarketers, setTotalMarketers] = useState("");
  const [marketerName, setMarketerName] = useState("");
  // const [totalMarketersThisWeek, setTotalMarketersThisWeek] = useState("");
  // const [totalMarketersLastWeek, setTotalMarketersLastWeek] = useState("");
  const [totalSubscriptions, setTotalSubscriptions] = useState("");
  const [totalSubscriptionsThisWeek, setTotalSubscriptionsThisWeek] =
    useState("");
  const [totalSubscriptionsLastWeek, setTotalSubscriptionsLastWeek] =
    useState("");
  const [subscriptionIncreaseLast7Days, setSubscriptionIncreaseLast7Days] =
    useState("");
  const [totalUnsubscriptions, setTotalUnsubscriptions] = useState("");
  const [totalUnsubscriptionsThisWeek, setTotalUnsubscriptionsThisWeek] =
    useState("");
  const [unsubscriptionIncreaseLast7Days, setUnsubscriptionIncreaseLast7Days] =
    useState("");
  const [totalUnsubscriptionsLastWeek, setTotalUnsubscriptionsLastWeek] =
    useState("");
  const [totalRevenue, setTotalRevenue] = useState("");
  const [totalRevenueThisWeek, setTotalRevenueThisWeek] = useState("");
  const [totalRevenueLastWeek, setTotalRevenueLastWeek] = useState("");
  const [revenueIncreaseLast7Days, setRevenueIncreaseLast7Days] = useState("");
  const [
    percentageIncreaseInMarketersLast7Days,
    setPercentageIncreaseInMarketersLast7Days,
  ] = useState("");

  // newly added for compnay dashboard
  const [remarketingCount, setRemarketingCount] = useState("");
  const [marketerId, setMarketerId] = useState("");

  const location = useLocation();
  const rowData = location.state?.rowData;
  // console.log("company data", rowData);

  // revenue view
  const [isRevenueVisible, setIsRevenueVisible] = useState(false);
  const [conversionSuccessRate, setConversionSuccessRate] = useState("");
  // Toggle function for balance visibility
  const toggleRevenueVisibility = () => {
    setIsRevenueVisible((prevState) => !prevState);
  };

  useEffect(() => {
    if (rowData) {
      //  console.log("single marketer  id", rowData);
      setMarketerId(rowData.id || "");
      setMarketerName(rowData.name || "");
      // setName(rowData.name || "");
    }
  }, [rowData]);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading1(false);
    }, 800);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading2(false);
    }, 1000);
  }, []);

  useEffect(() => {
    let script;
    const loadScript = (src) => {
      return new Promise((resolve, reject) => {
        script = document.createElement("script");
        script.src = src;
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.body.appendChild(script);
      });
    };
    Promise.all([loadScript("../assets/libs_/js/custom.min.js")])
      .then(() => {
        // Both scripts are loaded
      })
      .catch((error) => {
        console.error("Error loading scripts:", error);
      });
    return () => {
      if (script) {
        document.body.removeChild(script);
      }
    };
  }, []);

  useEffect(() => {
    if (window.eduMin) {
      window.eduMin.load();
    } else {
      console.log("eduMin is not defined");
    }
    return () => {
      if (window.eduMin && typeof window.eduMin.destroy === "function") {
        window.eduMin.destroy();
      }
    };
  }, [window.eduMin]);
  const navigate = useNavigate();

  useEffect(() => {
    const token = getToken();
    if (!token) {
      Swal.fire({
        title: "Error",
        text: "Please log in first.",
        icon: "error",
      });

      // Clear specific dashboard data from local storage
      localStorage.removeItem("companyName");
      localStorage.removeItem("userVASData");

      // Redirect to the login page
      navigate("/login");
      return;
    }

    const fetchData = async () => {
      if (!marketerId) return;
      setLoading(true);
      try {
        const url = `${
          API_ROUTES.GET_SINGLE_MARKETER_DASHBOARD
        }/${encodeURIComponent(marketerId)}`;

        const response = await fetch(url, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          const errorMessages = {
            400: "Bad Request. Please check your input.",
            401: "Unauthorized. Please log in again.",
            404: "Not Found. The requested resource could not be found.",
            500: "Internal Server Error. Please try again later.",
            503: "Service Unavailable. Please try again later.",
          };

          if (response.status === 401) {
            // Show SweetAlert
            Swal.fire({
              title: "Unauthorized",
              text: "Please log in again.",
              icon: "error",
            }).then(() => {
              // Clear data from local storage
              localStorage.removeItem("userVASData");
              localStorage.removeItem("companyName");
              // Redirect the user to the login page
              navigate("/login");
            });
          } else {
            Swal.fire({
              title: "<span className='error_title'>Error</span>",
              html:
                errorMessages[response.status] || `Unexpected error occurred.`,
              icon: "error",
            });
          }

          throw new Error(
            errorMessages[response.status] || "Unexpected error."
          );
        }

        const result = await response.json();
         console.log("api response for admin dashboard", result.data);

        // Handle the main dashboard data
        setDailySubscriptions(result?.data?.dailySubscriptions || []);
        setDailyRevenue(result?.data?.dailyRevenue || []);
        setMarketersCost(result?.data?.marketerCost || "");
        setTotalMarketers(result?.data?.totalMarketers || "");
        // setTotalMarketersThisWeek(result?.data?.totalMarketersThisWeek || "");
        // setTotalMarketersLastWeek(result?.data?.totalMarketersLastWeek || "");
        setTotalSubscriptions(result?.data?.totalSubscriptions || "");
        setTotalSubscriptionsThisWeek(
          result?.data?.totalSubscriptionsThisWeek || ""
        );
        setTotalSubscriptionsLastWeek(
          result?.data?.totalSubscriptionsLastWeek || ""
        );
        setSubscriptionIncreaseLast7Days(
          result?.data?.subscriptionIncreaseLast7Days || ""
        );
        setTotalUnsubscriptions(result?.data?.totalUnsubscriptions || "");
        setTotalUnsubscriptionsThisWeek(
          result?.data?.totalUnsubscriptionsThisWeek || ""
        );
        setUnsubscriptionIncreaseLast7Days(
          result?.data?.unsubscriptionIncreaseLast7Days || ""
        );
        setTotalUnsubscriptionsLastWeek(
          result?.data?.totalUnsubscriptionsLastWeek || ""
        );
        setTotalRevenue(result?.data?.totalRevenue || "");
        setTotalRevenueThisWeek(result?.data?.totalRevenueThisWeek || "");
        setTotalRevenueLastWeek(result?.data?.totalRevenueLastWeek || "");
        setRevenueIncreaseLast7Days(result?.data?.revenueIncreaseLast7Days || "");
        setPercentageIncreaseInMarketersLast7Days(
          result?.data?.percentageIncreaseInMarketersLast7Days || ""
        );
        // newly added for company dashbaord
        setRemarketingCount(result?.data?.remarketingCount || "");
        setConversionSuccessRate(result?.data?.conversionSuccessRate || 0);

        // console.log("Marketer dashboard response:", result.data);

        // Process dailyRevenue into datas1
        // const data1 = result.data.dailyRevenue.map((item) => ({
        //   y: item.day, // Day of the week
        //   a: item.lastRevenue || 0, // Last week revenue
        //   b: item.upperRevenue || 0, // This week revenue
        // }));

        // console.log("Mapped daily subscription data:", data1);

        // Process dailySubscriptions into data2
        // const data2 = result.data.dailySubscriptions.map((item) => ({
        //   y: item.day, // Day of the week
        //   a: item.count, // Subscription count
        //   b: item.unsubCount, // unSubscription count
        // }));

        // console.log("Mapped daily revenue data:", data2);

        // Load data into the chart (only once)
        // if (window.eduMin) {
        //   window.eduMin.load( data2);
        // }
      } catch (error) {
        console.error("Error fetching data:", error);
        Swal.fire({
          icon: "error",
          html: error.message,
          title: "Error",
        });
      } finally {
        setLoading(false);
      }
    };

    fetchData();

    // return () => {
    //   if (window.eduMin && typeof window.eduMin.destroy === "function") {
    //     window.eduMin.destroy();
    //   }
    // };
  }, [marketerId]);

  // currency formatter
  const formatCurrency = (value) =>
    new Intl.NumberFormat("en-NG", {
      style: "currency",
      currency: "NGN",
    }).format(value);

  // number format
  const formatNumber = (value) => new Intl.NumberFormat("en-NG").format(value);

  return (
    <>
      <div id="main-wrapper" className={isLoaded ? "show" : ""}>
        <TopNav />
        <Notifications />
        <NavHeader2 />
        <Sidebar />

        <div className="content-body mt-2">
          <div className="container-fluid">
            <h1 className="card px-1 py-1">{marketerName}</h1>
            <div className="row">
              {loading ? (
                <Spinner loading={loading} />
              ) : (
                <div className="col-xl-3 col-xxl-3 col-sm-6 mb--30_">
                  <div className="widget-stat card bg-primary">
                    <div className="card-body pt-4 position-relative">
                      <div className="media">
                        <span className="me-3">
                          <i className="la la-money-bill-alt"></i>
                        </span>
                        <div className="media-body text-white">
                          <p className="mb-1">Total Revenues</p>

                          {/* Revenue Value */}
                          <h3 className="text-white">
                            {isRevenueVisible
                              ? formatCurrency(totalRevenue)
                              : "*****"}
                          </h3>

                          <div className="progress mb-2 bg-white">
                            <div
                              className="progress-bar progress-animated bg-white"
                              style={{
                                width: `${revenueIncreaseLast7Days ?? 0}%`,
                              }}
                            ></div>
                          </div>
                          <small>
                            {revenueIncreaseLast7Days !== undefined &&
                            revenueIncreaseLast7Days !== null ? (
                              <>
                                {Math.abs(revenueIncreaseLast7Days).toFixed(2)}%
                                &nbsp;&nbsp;
                                {revenueIncreaseLast7Days < 0
                                  ? "Decrease in 7 Days"
                                  : "Increase in 7 Days"}
                              </>
                            ) : (
                              "0% &nbsp;&nbsp; Increase in 7 Days"
                            )}
                          </small>
                        </div>
                      </div>

                      {/* Icon Button Positioned at Top Right */}
                      <button
                        onClick={toggleRevenueVisibility}
                        className=" rounded-end-circle bg-primary border-0 text-white position-absolute top-0 end-0 p-2"
                        style={{
                          cursor: "pointer",
                          fontSize: "25px", // Small icon size
                        }}
                      >
                        <i
                          className={`la ${
                            isRevenueVisible ? "la-eye-slash" : "la-eye"
                          }`}
                        ></i>
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {loading ? (
                <Spinner loading={loading} />
              ) : (
                <div className="col-xl-3 col-xxl-3 col-sm-6">
                  <div className="widget-stat card bg-secondary">
                    <div className="card-body pt-4">
                      <div className="media">
                        <span className="me-3">
                          <i className="la la-bar-chart"></i>
                        </span>
                        <div className="media-body text-white">
                          <p className="mb-1">Subscription</p>
                          <h3 className="text-white">{totalSubscriptions}</h3>
                          <div className="progress mb-2 bg-white">
                            <div
                              className="progress-bar progress-animated bg-white"
                              style={{
                                width: `${
                                  subscriptionIncreaseLast7Days ?? 0
                                } %`,
                              }}
                            ></div>
                          </div>
                          <small>
                            {subscriptionIncreaseLast7Days !== undefined &&
                            subscriptionIncreaseLast7Days !== null ? (
                              <>
                                {Math.abs(
                                  subscriptionIncreaseLast7Days
                                ).toFixed(2)}
                                % &nbsp;&nbsp;
                                {subscriptionIncreaseLast7Days < 0
                                  ? "Decrease in 7 Days"
                                  : "Increase in 7 Days"}
                              </>
                            ) : (
                              "0% &nbsp;&nbsp; Increase in 7 Days"
                            )}
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {loading ? (
                <Spinner loading={loading} />
              ) : (
                <div className="col-xl-3 col-xxl-3 col-sm-6">
                  <div className="widget-stat card bg-danger">
                    <div className="card-body pt-4">
                      <div className="media">
                        <span className="me-3">
                          <i className="la la-bar-chart"></i>
                        </span>
                        <div className="media-body text-white">
                          <p className="mb-1">UnSubscriptions</p>
                          <h3 className="text-white">
                            {formatNumber(totalUnsubscriptions)}
                          </h3>
                          <div className="progress mb-2 bg-white">
                            <div
                              className="progress-bar progress-animated bg-white"
                              style={{
                                width: `${
                                  unsubscriptionIncreaseLast7Days ?? 0
                                } %`,
                              }}
                            ></div>
                          </div>
                          <small>
                            {unsubscriptionIncreaseLast7Days !== undefined &&
                            unsubscriptionIncreaseLast7Days !== null ? (
                              <>
                                {Math.abs(
                                  unsubscriptionIncreaseLast7Days
                                ).toFixed(2)}
                                % &nbsp;&nbsp;
                                {unsubscriptionIncreaseLast7Days < 0
                                  ? "Decrease in 7 Days"
                                  : "Increase in 7 Days"}
                              </>
                            ) : (
                              "0% &nbsp;&nbsp; Increase in 7 Days"
                            )}
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {loading ? (
                <Spinner loading={loading} />
              ) : (
                <div className="col-xl-3 col-xxl-3 col-sm-6">
                  <div className="widget-stat card bg-dark">
                    <div className="card-body pt-4">
                      <div className="media">
                        <span className="me-3">
                          <i className="la la-users"></i>
                        </span>
                        <div className="media-body text-white">
                          <p className="mb-1">Remarketing Count</p>
                          <h3 className="text-white">
                            {formatNumber(remarketingCount ?? 0)}
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="row">
              {loading ? (
                <Spinner loading={loading} />
              ) : (
                <div className="col-xl-3 col-xxl-3 col-sm-6">
                  <div className="widget-stat card bg-warning text-dark">
                    <div className="card-body pt-4">
                      <div className="media">
                        <span className="me-3">
                          <i className="la la-tasks"></i>
                        </span>
                        <div className="media-body text-white">
                          <p className="mb-1">Conversion Rate</p>
                          <h3 className="text-white">
                            {conversionSuccessRate ?? 0}%
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {loading ? (
                <Spinner loading={loading} />
              ) : (
                <div className="col-xl-3 col-xxl-3 col-sm-6">
                  <div className="widget-stat card bg-success text-dark">
                    <div className="card-body pt-4">
                      <div className="media">
                        <span className="me-3">
                          <i className="la la-building"></i>
                        </span>
                        <div className="media-body text-white">
                          <p className="mb-1">Market Cost</p>
                          <h3 className="text-white">
                            {formatCurrency(marketersCost) ?? 0}
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="row">
              {/* {loading ? (
                <Spinner loading={loading} />
              ) : (
                <div className="col-xl-4 col-xxl-4 col-sm-6">
                  <div className="widget-stat card bg-dark">
                    <div className="card-body pt-4">
                      <div className="media">
                        <span className="me-3">
                          <i className="la la-building"></i>
                        </span>
                        <div className="media-body text-white">
                          <p className="mb-1">Remarketing Count</p>
                          <h3 className="text-white">
                            {formatNumber(remarketingCount ?? 0)}
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )} */}
              {loading ? (
                <Spinner loading={loading} />
              ) : (
                // breakdown
                <div className="col-xl-6 col-xxl-6 col-sm-6">
                  <div className="card">
                    <div className="card-header pl-20 pr-20">
                      <h3 className="card-title">
                        <label
                          className="col-form-label"
                          style={{
                            fontSize: 14,
                            fontWeight: "bold",
                            marginBottom: -10,
                            color: "#6a73fa",
                          }}
                        >
                          TOTAL THIS WEEK
                        </label>
                      </h3>
                    </div>
                    <div className="card-body mt--10 mt-xs-0 pl-20 pr-20 pb-xs-30">
                      {/* <div id="morris_donught_2" className="morris_chart_height ltr" style={{minHeight: '300px'}}></div> */}
                      <div className="mb-4">
                        {/* <label
                          className="col-form-label"
                          style={{
                            fontSize: 14,
                            fontWeight: "bold",
                            marginBottom: -10,
                            color: "#6a73fa",
                          }}
                        >
                          TOTAL THIS WEEK
                        </label> */}

                        <div className="mb--8 row">
                          <div className="col-5">
                            <label className="col-form-label">Revenue</label>
                          </div>
                          <div className="col-7">
                            <label className="col-form-label">
                              {formatCurrency(totalRevenueThisWeek ?? 0)}
                            </label>
                          </div>
                        </div>

                        {/* <div className="mb--8 row">
                          <div className="col-5">
                            <label className="col-form-label">Marketers</label>
                          </div>
                          <div className="col-7">
                            <label className="col-form-label">
                              {formatNumber(totalMarketersThisWeek ?? 0)}
                            </label>
                          </div>
                        </div> */}

                        <div className="mb--8 row">
                          <div className="col-5">
                            <label className="col-form-label">
                              Subscription
                            </label>
                          </div>
                          <div className="col-7">
                            <label className="col-form-label">
                              {formatNumber(totalSubscriptionsThisWeek ?? 0)}
                            </label>
                          </div>
                        </div>

                        <div className="mb--8 row">
                          <div className="col-5">
                            <label className="col-form-label">
                              UnSubscription
                            </label>
                          </div>
                          <div className="col-7">
                            <label className="col-form-label">
                              {" "}
                              {formatNumber(totalUnsubscriptionsThisWeek ?? 0)}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {loading ? (
                <Spinner loading={loading} />
              ) : (
                <div className="col-xl-6 col-xxl-6 col-sm-6">
                  <div className="card">
                    <div className="card-header pl-20 pr-20">
                      <h3 className="card-title">
                        <label
                          className="col-form-label"
                          style={{
                            fontSize: 14,
                            fontWeight: "bold",
                            marginBottom: -10,
                            color: "#6a73fa",
                          }}
                        >
                          TOTAL LAST WEEK
                        </label>
                      </h3>
                    </div>
                    <div className="card-body mt--10 mt-xs-0 pl-20 pr-20 pb-xs-30">
                      <div>
                        <div className="mb--8 row">
                          <div className="col-5">
                            <label className="col-form-label">Revenue</label>
                          </div>
                          <div className="col-7">
                            <label className="col-form-label">
                              {formatCurrency(totalRevenueLastWeek ?? 0)}
                            </label>
                          </div>
                        </div>

                        {/* <div className="mb--8 row">
                          <div className="col-5">
                            <label className="col-form-label">Marketers</label>
                          </div>
                          <div className="col-7">
                            <label className="col-form-label">
                              {formatNumber(totalMarketersLastWeek ?? 0)}
                            </label>
                          </div>
                        </div> */}

                        <div className="mb--8 row">
                          <div className="col-5">
                            <label className="col-form-label">
                              Subscription
                            </label>
                          </div>
                          <div className="col-7">
                            <label className="col-form-label">
                              {formatNumber(totalSubscriptionsLastWeek ?? 0)}
                            </label>
                          </div>
                        </div>

                        <div className="mb--8 row">
                          <div className="col-5">
                            <label className="col-form-label">
                              UnSubscription
                            </label>
                          </div>
                          <div className="col-7">
                            <label className="col-form-label">
                              {formatNumber(totalUnsubscriptionsLastWeek ?? 0)}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                // sub
                // <div className="col-xl-4 col-xxl-4 col-sm-6">
                //   <div className="card">
                //     <div className="card-header">
                //       <h3 className="card-title">Subscription Analytics</h3>
                //     </div>
                //     {isLoading2 && (
                //       <div style={{ position: "relative", top: 60 }}>
                //         {/* <LoadingSpinner /> */}
                //         <Spinner loading={loading} />
                //       </div>
                //     )}
                //     <div
                //       className="card-body"
                //       style={{ height: isLoading2 ? "210px" : "auto" }}
                //     >
                //       <div
                //         id="morris_bar"
                //         className="morris_chart_height ltr"
                //         style={{
                //           minHeight: "300px",
                //           opacity: isLoading2 ? 0 : 1,
                //         }}
                //       ></div>
                //     </div>
                //   </div>
                // </div>
              )}
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
};

export default SingleMarketerDashboard;
